import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import './styles/main.scss';
import Router from './router';
import { SiteConfigProvider } from './contexts/SiteConfigProvider';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#00bfa6',
          borderRadius: 8,
        },
      }}
    >
      <SiteConfigProvider>
        <Router />
      </SiteConfigProvider>
    </ConfigProvider>
  </React.StrictMode>
);
